.selectInput {
  --ixf-select-input-min-width: 130px;
  --ixf-select-icon-height: 1rem;
  --ixf-select-icon-width: 1rem;
  --ixf-select-input-border-weight: 1px;
  --ixf-select-input-trigger-align: stretch;
  --ixf-select-input-padding-left: var(--ixf-input-padding-horizontal);

  position: relative;
  min-width: var(--ixf-select-input-min-width);

  .label {
    pointer-events: none;

    &.isFloating {
      --ixf-input-label-active-offset: var(--ixf-space-2);
    }
  }

  &.withPrefixIcon {
    --ixf-select-input-padding-left: var(--ixf-space-3);

    .label {
      --ixf-input-label-active-offset-horizontal: var(--ixf-space-5);
    }
  }

  &.hideLabel {
    .label {
      display: none;
    }

    --ixf-input-label-active-offset: 0;
    --ixf-input-label-gap: 0;
    --ixf-input-padding: var(--ixf-input-padding-vertical)
      var(--ixf-input-padding-horizontal) var(--ixf-input-padding-vertical)
      var(--ixf-select-input-padding-left) !important;

    .triggerContainer .prefixIcon,
    .triggerContainer .trigger .suffix {
      transform: none;
    }
  }

  .inputElement {
    border-left: var(--ixf-select-input-border-weight) solid
      var(--ixf-input-border-color);
    border-right: var(--ixf-select-input-border-weight) solid
      var(--ixf-input-border-color);

    &:last-of-type {
      border-bottom: var(--ixf-select-input-border-weight) solid
        var(--ixf-input-border-color);
      border-bottom-left-radius: var(--ixf-input-border-radius);
      border-bottom-right-radius: var(--ixf-input-border-radius);
    }
  }

  &.isFullWidth {
    width: 100%;
  }

  &.isDisabled {
    .triggerContainer {
      cursor: default;
    }
  }

  .triggerContainer {
    cursor: pointer;
    width: 100%;
    position: relative;
    border-top: var(--ixf-select-input-border-weight) solid
      var(--ixf-input-border-color);
    border-top-left-radius: var(--ixf-input-border-radius);
    border-top-right-radius: var(--ixf-input-border-radius);

    .triggerSelection {
      flex: 1 1 100%;
      min-width: 0;
    }

    .iconContainer {
      padding-right: var(--ixf-input-padding-horizontal);

      svg path {
        fill: var(--ixf-input-font-color);
      }

      .toggleIcon {
        height: var(--ixf-select-icon-height);
        width: var(--ixf-select-icon-width);

        &.isOpen {
          transform: rotate(180deg);
        }
      }

      .clearButton {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          height: var(--ixf-select-icon-height);
          width: var(--ixf-select-icon-width);
        }
      }
    }

    .trigger {
      align-self: var(--ixf-select-input-trigger-align);
      padding: var(--ixf-input-padding);
      cursor: pointer;
      flex: 1 1 auto;
      min-width: 0;

      .placeholder {
        color: var(--ixf-input-placeholder-color);
      }

      .item {
        flex: 1 1 auto;
        color: var(--ixf-input-font-color);
        font-size: var(--ixf-input-font-size);
        line-height: var(--ixf-input-line-height);
        font-weight: var(--ixf-input-font-weight);
      }

      .option {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .suffix {
        transform: translateY(-6px);
        display: inline-flex;
        flex-shrink: 0;
        margin-left: auto;
      }

      &:disabled {
        cursor: default;
      }

      &:focus {
        outline: none;
      }

      &:focus-visible {
        outline: none;
        border: none;
        box-shadow: none;
      }
    }

    .prefixIcon {
      transform: translateY(-6px);
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 auto;
    }
  }

  &.hasValue {
    --ixf-input-padding: calc(
        var(--ixf-input-padding-vertical) + var(--ixf-input-label-active-offset)
      )
      var(--ixf-input-padding-horizontal)
      calc(
        var(--ixf-input-padding-vertical) - var(
            --ixf-input-label-active-offset
          ) +
          var(--ixf-input-label-gap)
      )
      var(--ixf-select-input-padding-left);
  }

  &.variant {
    &-button-light-small {
      --ixf-input-padding-horizontal: var(--ixf-space-2) !important;
      --ixf-input-padding: 2px var(--ixf-space-1) var(--ixf-space-1)
        var(--ixf-space-3) !important;
      --ixf-input-height: 32px;
      --ixf-input-font-size: 0.875rem;
      --ixf-input-line-height: 1.5rem;
      --ixf-select-input-min-width: fit-content;
      --ixf-select-input-trigger-align: center;

      .triggerContainer {
        border-radius: 6px;
      }
    }

    &-button-light-medium {
      --ixf-input-padding-horizontal: var(--ixf-space-3) !important;
      --ixf-input-padding: var(--ixf-space-2) var(--ixf-space-3)
        var(--ixf-space-2) var(--ixf-space-4) !important;
      --ixf-input-height: 2.5rem;
      --ixf-input-font-size: 0.875rem;
      --ixf-input-line-height: 1.5rem;
      --ixf-select-input-min-width: fit-content;
      --ixf-select-input-trigger-align: center;
    }
  }
}
